export const FETCH_LATEST_CSS = 'FETCH_LATEST_CSS';
export const FETCH_LATEST_CSS_FETCHING = 'FETCH_LATEST_CSS_FETCHING';
export const FETCH_LATEST_CSS_SUCCESS = 'FETCH_LATEST_CSS_SUCCESS';
export const FETCH_LATEST_CSS_FAIL = 'FETCH_LATEST_CSS_FAIL';

export const FETCH_CSS_RANGE_DATA = 'FETCH_CSS_RANGE_DATA';
export const FETCH_CSS_RANGE_DATA_SUCCESS = 'FETCH_CSS_RANGE_DATA_SUCCESS';
export const FETCH_CSS_RANGE_DATA_ERROR = 'FETCH_CSS_RANGE_DATA_ERROR';
export const FETCH_CSS_RANGE_DATA_FETCHING = 'FETCH_CSS_RANGE_DATA_FETCHING';

export const ADD_CSS = 'ADD_CSS';
export const ADD_CSS_START = 'ADD_CSS_START';
export const ADD_CSS_SUCCESS = 'ADD_CSS_SUCCESS';
export const ADD_CSS_FAIL = 'ADD_CSS_FAIL';

export const DELETE_CSS = 'DELETE_CSS';
export const DELETING_CSS = 'DELETING_CSS';
export const DELETING_CSS_SUCCESS = 'DELETING_CSS_SUCCESS';
export const DELETING_CSS_FAIL = 'DELETING_CSS_FAIL';
